// Actions has been kept in seperete comps

export const USER_LOADING = "USER_LOADING";
export const FETCH_USERS = "FETCH_USERS";
export const UPDATE_USER = "UPDATE_USER";

export const ADD_USER = "ADD_USER";
export const USER_TO_EDIT = "USER_TO_EDIT";
export const DELETE_USER = "DELETE_USER";

export const SET_ERRORS = "SET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
